import React, { Component } from "react";
import MyTitle from "../myTitle";
import Swiper, { Navigation, Thumbs, Lazy } from "swiper";
// import { Swiper, SwiperSlide } from 'swiper/react'
import styleObj from "./style.module.scss";
import "swiper/swiper-bundle.css";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/lazy/lazy.scss";
import "./style.scss";
import title from "../../assets/imgs/SideLights2021.png";

Swiper.use([Navigation, Thumbs, Lazy]);

export default class SideLights extends Component {
  // constructor(props) {
  //   super(props)
  // }
  componentDidMount() {
    if (this.props.list.length) {
      this.thumb_swiper = new Swiper(".pic-bottom-wrap", {
        spaceBetween: 15,
        slidesPerView: 5,
        loop: false,
        freeMode: true,
        loopedSlides: 5, //looped slides should be the same
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        lazy: true,
      });
      this.swiper = new Swiper(".pic-top-wrap", {
        spaceBetween: 10,
        // autoplay: true,
        loop: false,
        loopedSlides: 5, //looped slides should be the same
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        navigation: {
          nextEl: ".swiper-button-custom-next",
          prevEl: ".swiper-button-custom-prev",
        },
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 2,
        },
        thumbs: {
          swiper: this.thumb_swiper,
        },
      });
      // console.log(this.swiper,this.thumbs_swiper);
      // this.swiper.thumbs.swiper = this.thumbs_swiper
    }
  }
  render() {
    let { list, sidelightsBg, meta } = this.props;
    return (
      !!list.length && (
        <div className={styleObj["side-lights-wrap"]}>
          <MyTitle
            meta={meta}
            title={title}
            mainTitle="现场花絮"
            subTitle="SIDELIGHTS"
          />
          {meta?.is2021 && (
            <>
              <img
                className={styleObj["yun"]}
                src={require("../../assets/imgs/yun2021-2.png")}
              />
              <img
                className={styleObj["yun2"]}
                src={require("../../assets/imgs/yun2021.png")}
              />
            </>
          )}
          <div className={styleObj["content-wrap"]}>
            <div
              className={styleObj["content"]}
              style={{
                backgroundImage: meta?.is2021
                  ? `url(${require("../../assets/imgs/SideBackground.png")})`
                  : `url(//s2.jiguo.com/${sidelightsBg})`,
              }}
            >
              <div
                className={`${styleObj["pic-top"]} swiper-container pic-top-wrap`}
              >
                <div className={`${styleObj["swiper-wrapper"]} swiper-wrapper`}>
                  {list.map((item, i) => (
                    <div
                      key={i}
                      className={`${styleObj["swiper-slide"]}  swiper-slide swiper-lazy`}
                      // data-background={`${require(`../../assets/imgs/${item}`)}`}
                      data-background={`//s2.jiguo.com/${item}?imageView2/1/w/1600/h/1067`}
                    >
                      <div className="swiper-lazy-preloader"></div>
                    </div>
                  ))}
                </div>
                {/* <Swiper
              className={`${styleObj['swiper-wrapper']} swiper-wrapper`}
              spaceBetween={10}
              loopedSlides={5}
              // lazy={true}
              navigation={{
                nextEl: '.swiper-button-custom-next',
                prevEl: '.swiper-button-custom-prev'
              }}
              watchSlidesVisibility={true}
              thumbs={{
                swiper: this.thumbs_swiper
              }}
              onSwiper={swiper => (this.swiper = swiper)}
            >
              {list.map((item, i) => (
                <SwiperSlide key={i}>
                  <div
                    className={`${styleObj['swiper-slide-img']} swiper-lazy`}
                    data-background={`${require(`../../assets/imgs/${item}`)}`}
                  >
                    <div className="swiper-lazy-preloader"></div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper> */}
                <div
                  className="swiper-left"
                  onClick={() => {
                    this.swiper.slidePrev();
                  }}
                ></div>
                <div
                  className="swiper-right"
                  onClick={() => {
                    this.swiper.slideNext();
                  }}
                ></div>
              </div>
              <div className={`${styleObj["pic-bottom-box"]} pic-bottom-box`}>
                <div
                  className={`${styleObj["pic-bottom"]} swiper-container pic-bottom-wrap`}
                >
                  <div
                    className={`${styleObj["swiper-wrapper"]} swiper-wrapper`}
                  >
                    {list.map((item, i) => (
                      <div
                        key={i}
                        className={`${styleObj["swiper-slide"]} swiper-slide swiper-lazy`}
                        // data-background={`${require(`../../assets/imgs/${item}`)}`}
                        data-background={`//s2.jiguo.com/${item}?imageView2/1/w/273/h/182`}
                      >
                        <div className="swiper-lazy-preloader"></div>
                      </div>
                    ))}
                  </div>
                  {/* <Swiper
                className={`${styleObj['swiper-wrapper']} swiper-wrapper`}
                spaceBetween={15}
                slidesPerView={5}
                loopedSlides={5}
                freeMode={true}
                // lazy={true}
                watchSlidesVisibility={true}
                watchSlidesProgress={true}
                onSwiper={swiper => (this.thumbs_swiper = swiper)}
              >
                {list.map((item, i) => (
                  <SwiperSlide key={i}>
                    <div
                      className={`${styleObj['swiper-slide-img']} swiper-lazy`}
                      data-background={`${require(`../../assets/imgs/${item}`)}`}
                    >
                      <div className="swiper-lazy-preloader"></div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper> */}
                </div>
                <div
                  className={`${
                    styleObj["swiper-button-prev"]
                  } swiper-button-custom-prev ${styleObj["swiper-button"]} ${
                    meta?.is2021 && styleObj["swiper-button-prev-2021"]
                  }`}
                ></div>
                <div
                  className={`${
                    styleObj["swiper-button-next"]
                  } swiper-button-custom-next ${styleObj["swiper-button"]} ${
                    meta?.is2021 && styleObj["swiper-button-next-2021"]
                  }`}
                ></div>
              </div>
            </div>
            {/* <div className={styleObj['pendant-left']}></div> */}
            {/* <div className={styleObj['pendant-right']}></div> */}
          </div>
        </div>
      )
    );
  }
}
